export default __webpack_public_path__ + "media/plus/plus-customization-1a69c22b.jpg";